/**
 * @generated SignedSource<<7972ab017b8eb6da30b022b9e947eaf2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ServiceAccountAuthTokenInput = {
  expiresAt?: string | null;
};
export type ServiceAccountCreateScreenMutation$variables = {
  name: string;
  tokens?: ReadonlyArray<ServiceAccountAuthTokenInput> | null;
};
export type ServiceAccountCreateScreenMutation$data = {
  readonly store: {
    readonly createServiceAccount: {
      readonly authTokens: ReadonlyArray<{
        readonly token: string | null;
      }>;
      readonly id: string;
    };
  };
};
export type ServiceAccountCreateScreenMutation = {
  response: ServiceAccountCreateScreenMutation$data;
  variables: ServiceAccountCreateScreenMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "name"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "tokens"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "name",
    "variableName": "name"
  },
  {
    "kind": "Variable",
    "name": "tokens",
    "variableName": "tokens"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "token",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ServiceAccountCreateScreenMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "StoreMutations",
        "kind": "LinkedField",
        "name": "store",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "ServiceAccount",
            "kind": "LinkedField",
            "name": "createServiceAccount",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "ServiceAccountAuthToken",
                "kind": "LinkedField",
                "name": "authTokens",
                "plural": true,
                "selections": [
                  (v3/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ServiceAccountCreateScreenMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "StoreMutations",
        "kind": "LinkedField",
        "name": "store",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "ServiceAccount",
            "kind": "LinkedField",
            "name": "createServiceAccount",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "ServiceAccountAuthToken",
                "kind": "LinkedField",
                "name": "authTokens",
                "plural": true,
                "selections": [
                  (v3/*: any*/),
                  (v2/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "966b7af4e4bb6b4d6d19e2392fc140e2",
    "id": null,
    "metadata": {},
    "name": "ServiceAccountCreateScreenMutation",
    "operationKind": "mutation",
    "text": "mutation ServiceAccountCreateScreenMutation(\n  $name: String!\n  $tokens: [ServiceAccountAuthTokenInput!]\n) {\n  store {\n    createServiceAccount(name: $name, tokens: $tokens) {\n      id\n      authTokens {\n        token\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "cb6e071086170216803b0ca378aeec96";

export default node;
